import React from "react";
import { Button, Stack, Text, Box } from "@chakra-ui/react";
import { Control, useFormState } from "react-hook-form";
import BottomAction from "./BottomAction";

type PropTypes = {
  control: Control<any>;
  caption: string;
  flavourText?: string;
  isLoading?: boolean;
  isEnabled?: boolean;
};

const SubmitButton = (props: PropTypes) => {
  const { control, caption, flavourText, isLoading } = props;
  const { isValid } = useFormState({ control });
  const isEnabled = "isEnabled" in props ? props.isEnabled : true;
  return (
    <>
      <Box mt={{ base: 32, md: 2 }} />
      <BottomAction>
        <Stack m={0} w="100%" alignItems="center">
          <Button
            w="100%"
            type="submit"
            variant={isValid && isEnabled ? "primary" : undefined}
            size="lg"
            isLoading={isLoading}
            disabled={!isEnabled}
          >
            {caption}
          </Button>
          {flavourText && (
            <Text fontSize="xs" textAlign="center" maxW="50em">
              {flavourText}
            </Text>
          )}
        </Stack>
      </BottomAction>
    </>
  );
};

export default SubmitButton;
